import {z} from "zod"

export const DefaultSocialProvider = z.enum(["Apple", "Google", "Facebook"])
export const CustomSocialProvider = z.enum(["LINE", "Twitter"])
export const AvailableSocialProvider = z.enum([
  ...DefaultSocialProvider.options,
  ...CustomSocialProvider.options,
])

export const CognitoDefaultIdentity = z.enum([
  "Google",
  "Facebook",
  "SignInWithApple",
])
export const CognitoCustomIdentity = z.enum(["LINE", "Twitter"])
export const AvailableCognitoIdentity = z.enum([
  ...CognitoCustomIdentity.options,
  ...CognitoDefaultIdentity.options,
])

export const FederatedSignInCustomState = z
  .object({
    provider: AvailableSocialProvider,
    originalSub: z.string(),
    isConnect: z.literal(true),
  })
  .or(
    z.object({
      provider: AvailableSocialProvider,
      isConnect: z.literal(false),
    }),
  )

export const CommonLoginWay = z.enum(["General"])
export const SocialLoginWay = z.enum([...AvailableCognitoIdentity.options])
export const AvailableLoginWay = z.enum([
  ...CommonLoginWay.options,
  ...SocialLoginWay.options,
])

export const CognitoUserIdentity = z.object({
  userId: z.string().catch(""),
  providerName: AvailableCognitoIdentity,
  providerType: z.string().catch(""),
  issuer: z.string().catch(""),
  primary: z.boolean().catch(false),
  dateCreated: z.number().catch(0),
})

export const CognitoUserIdentities = z.array(CognitoUserIdentity).default([])
